export default "__VITE_ASSET__e3ee9099__"